module.exports = __webpack_public_path__ + "img/16049c3.png";